import {
  ChangeToApprove,
  ETenantSettingActionType,
} from "./tenant-setting-change";
import { QCWorkflowObjective } from "app/js/src/domain/qc-workflow";

export class InsertQCWorkflowObjectiveChangeToApprove extends ChangeToApprove {
  constructor(
    public objective: QCWorkflowObjective,
    public message: string,
  ) {
    super(
      objective.id,
      ETenantSettingActionType.InsertQCWorkflowObjective,
      message,
    );
  }
}
